import type { StreamResource } from "@prequel/import-react";
import { useListStreams } from "@prequel/import-react";
import type { TableRow } from "@prequel/shared-components";

import ResourceTable from "@/components/ResourceTable";
import Timestamp from "@/components/Timestamp";

const COLUMNS = ["Name", "Destination", "Dataset", "Enabled", "Created"];

const formatBoolean = (value: boolean) => (value ? "Yes" : "No");

const mapStreamToRow = (stream: StreamResource): TableRow => ({
  id: stream.id,
  to: `/import/streams/${stream.id}`,
  cells: [
    { value: stream.name },
    { value: stream.destination_id },
    { value: stream.dataset_id },
    { value: formatBoolean(stream.is_enabled) },
    { value: <Timestamp timestamp={stream.created_at} /> },
  ],
});

const StreamsTable = () => {
  return (
    <ResourceTable<StreamResource>
      columns={COLUMNS}
      useQuery={useListStreams}
      rowMapper={mapStreamToRow}
      emptyMessage="No streams configured."
    />
  );
};

export default StreamsTable;
